import React, { Suspense, lazy } from 'react';
import Loader from '~components/main-loader';

const LawsPage = lazy(() => import('./index'));

function LawsPageLazy(props) {
    console.log('+++LAWS PAGE LAZY+++');
    return (
        <Suspense fallback={<Loader />}>
            <LawsPage {...props} />
        </Suspense>
    );
}

export default LawsPageLazy;
export { LawsPageLazy };



// WEBPACK FOOTER //
// ./src/routes/main/laws-page/lazy.js